import { AfterViewInit, Component, ComponentFactoryResolver, ComponentRef, EventEmitter, HostBinding, Input, Output, ViewChild, ViewContainerRef } from '@angular/core';
import * as _ from 'lodash';
import { NGXLogger } from 'ngx-logger';
import { Subject } from 'rxjs';
import { AppEventType, widgetComponentType } from 'src/app/enums';
import { gridItem } from 'src/app/models';
import { EventQueueService } from 'src/app/services/services/EventQueueService';
import { getTypeFor } from '../widget-helpers/helpers';
import { WidgetBaseComponent } from '../widgets/widget-base.component';

@Component({
    selector: 'app-widget-container',
    templateUrl: './widget-container.component.html',
    styleUrls: ['./widget-container.component.scss'],
    standalone: false
})
export class WidgetContainerComponent implements AfterViewInit {

  @HostBinding() public class = "app-widget-container";
  @Input() public gridItem: gridItem;
  @Input() resolvewizard?: boolean;
  @Input() public isEdit?: boolean;
  @Input() public isInWizard?: boolean;
  @Input() public colorSchemeId: number;
  @Input() public dataNotifier: Subject<any>;
  @Input() public stepper: any;
  @Output() complited = new EventEmitter<any>();
  @Output() restrictedDataEvent = new EventEmitter<boolean>();
  @ViewChild("vcr", { read: ViewContainerRef }) public vcr: ViewContainerRef;
  private componentType: widgetComponentType;
  private isViewInit: boolean = false;
  private previousGridItem: gridItem = null;
  private clearDashboardRequested: boolean = false;
  public componentFactory: ComponentRef<WidgetBaseComponent>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private logger: NGXLogger, private eventQueue: EventQueueService) { }

  ngAfterViewInit(): void {
    this.isViewInit = true;
    this.dataNotifier?.subscribe(value => {
      this.componentFactory.instance.dataEquality = false;
    });
    this.eventQueue.on(AppEventType.DashboardsCancelEvent).subscribe(event => {
      this.clearDashboardRequested = true;
    });
  }

  ngDoCheck() {
    if (this.gridItem.componentType !== this.componentType && this.isViewInit) {
      this.componentType = this.gridItem.componentType;
      this.createWidget();
    }
    else if (!_.isEqual(this.previousGridItem, this.gridItem) && this.componentFactory && this.componentFactory.instance) {
      this.previousGridItem = _.cloneDeep(this.gridItem);
      this.componentFactory.instance.colorSchemeId = this.gridItem.colorScheme;
      this.componentFactory.instance.gridItem = this.gridItem;
      if (this.clearDashboardRequested) {
        this.componentFactory.instance.dataEquality = false;
        this.clearDashboardRequested = false;
      }
    }
  }

  createWidget(): void {
    this.logger.trace('WidgetContainerComponent createWidget');
    if (this.componentType === undefined || this.componentType === null) return;
    this.vcr.clear();
    const componentType = getTypeFor(widgetComponentType[this.componentType] + (this.resolvewizard ? "_wizard" : ""));
    if (!componentType) return;
    const resolver = this.componentFactoryResolver.resolveComponentFactory(componentType);
    this.componentFactory = this.vcr.createComponent(resolver);
    this.componentFactory.instance.gridItem = this.gridItem;
    this.componentFactory.instance.isEdit = this.isEdit;
    this.componentFactory.instance.isInWizard = this.isInWizard;
    this.componentFactory.instance.dataEquality = true;
    this.componentFactory.instance.colorSchemeId = this.colorSchemeId;
    this.componentFactory.instance.stepper = this.stepper;
    this.componentFactory.instance.completed?.subscribe((comp) => this.complited.emit(comp));
    this.componentFactory.instance.restrictedDataEvent?.subscribe((comp) => this.restrictedDataEvent.emit(comp));
  }

  public ngOnDestroy(): void {
    this.logger.trace('WidgetContainerComponent Destroy');
    if (this.componentFactory?.instance?.completed) {
      this.componentFactory.instance.completed.unsubscribe();
    }
    if (this.componentFactory) {
      this.componentFactory.changeDetectorRef.detach();
      this.componentFactory.destroy();
      this.componentFactory = null;
    }
  }
}
